
import {Component} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import {ref, set} from 'firebase/database';
import {db} from '@/firebase';
import {PadoRoll} from '@/types/PadoRoll';
import PadoStatsComponent from '@/components/ParceDomine/PadoStatsComponent.vue';
import KimCharSheetComponent from "@/components/Kimakaan/KimCharSheetComponent.vue";
import AzrPlayerInventoryComponent from "@/components/Azuria/AzrPlayerInventoryComponent.vue";
import KimStatsComponent from "@/components/Kimakaan/KimStatsComponent.vue";
import KimSpellsComponent from "@/components/Kimakaan/KimSpellsComponent.vue";
import {KimRoll} from "@/types/KimRoll";
import KimPlayerInventoryComponent from "@/components/Kimakaan/KimPlayerInventoryComponent.vue";
import PadoMapComponent from "@/components/ParceDomine/PadoMapComponent.vue";
import {RollMixin} from '@/mixins/RollMixin';

@Component({
    components: {
        PadoMapComponent,
        KimPlayerInventoryComponent,
        KimSpellsComponent,
        KimStatsComponent,
        AzrPlayerInventoryComponent,
        KimCharSheetComponent,
        PadoStatsComponent
    },
})
export default class KimPlayerComponent extends mixins(RollMixin) {
    modalHealth = false;
    modalRi = false;
    modalHealthText = '';
    modalRiText = '';

    async roll(stat: string): Promise<void> {
        if (this.game && this.game.characters[this.$store.state.user.uid]) {
            const roll: KimRoll = new KimRoll(stat, this.game.characters[this.$store.state.user.uid].name);
            await roll.roll(this.game.characters[this.$store.state.user.uid], this.secret);
            await this.addRoll(roll);
            await this.addGlobalRoll(roll);
        }
    }

    async useAbility(name: string): Promise<void> {
        await (set(ref(db, `/jdrs/${this.game.id}/characters/${this.$store.state.user.uid}`), this.game.characters[this.$store.state.user.uid]));
        const abilityRoll = new PadoRoll(name, this.game.characters[this.$store.state.user.uid].name);
        abilityRoll.critic = false;
        abilityRoll.passed = true;
        abilityRoll.rolled = 0;
        abilityRoll.text = name;
        abilityRoll.setCSSClass();
        await this.addGlobalRoll(abilityRoll);
        await this.addRoll(abilityRoll);
    }
}
